export const typeList = [
    {
        name: "液位",
        value: "liquid_level"
    },
    {
        name: "流速",
        value: "flow_speed"
    },
]